// import React from "react";

// export const InfoPix = () => {
//   return (
//     <div id="infoPix">
//       <div className="container">
//         <div className="row">
//           <div className="col-xs-12 col-md-6">
//             <div>
//               <h2 style={{ color: "#f7931f" }}>Gateway</h2>
//               <h2 style={{ color: "#0dab49" }}>Api de Pix</h2>
//               <h2 style={{ color: "#f7931f" }}>e Api de Bolepix</h2>
//               <h3 style={{ color: "#0dab49" }}>
//                 Pix com as menores taxas do mercado
//               </h3>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

import React from "react";

export const InfoPix = () => {
  return (
    <div id="infoPix">
      <div className="overlay"></div>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-12 col-md-6 text-content">
            <div>
              <h2 style={{ color: "#F2D857" }}>Gateway</h2>
              <h2 style={{ color: "#A64812" }}>Api de Pix</h2>
              <h2 style={{ color: "#F2D857" }}>Api de Bolepix</h2>
              <h3 style={{ color: "#A64812" }}>
                Pix com as menores taxas do mercado
              </h3>
            </div>
          </div>
          <div className="col-12 col-md-6 image-content">
            <img
              src="/img/bolepix.webp"
              alt="Pix Illustration"
              className="pix-image"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
